var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"buy_vip_component"},[_c('div',{staticClass:"buy_vip",on:{"click":function($event){_vm.showModal = true}}},[_vm._v("绑定VIP查看全部")]),_c('cardBind',{attrs:{"showModal":_vm.showModal,"reload":_vm.reload,"routePath":_vm.routePath,"vipType":_vm.vipType},on:{"closeModal":_vm.hideModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }